import { useState } from "react";
import { Modal, Button } from "react-bootstrap";

// State for PdfPreviewModal:
//   const pdfPreview = usePdfPreview();
//   <ExportOptionsModal onPdfReady={pdfPreview.open} ... />
//   <PdfPreviewModal {...pdfPreview.modalProps} />
export function usePdfPreview() {
  const [preview, setPreview] = useState(null); // { url, fileName }

  const open = (blob, fileName) => {
    setPreview({ url: URL.createObjectURL(blob), fileName });
  };

  const close = () => {
    if (preview) URL.revokeObjectURL(preview.url);
    setPreview(null);
  };

  return { open, modalProps: { preview, onHide: close } };
}

// Shows an already-built PDF Blob with a download button. Showing a blob URL
// (instead of PDFViewer / PDFDownloadLink) means the PDF isn't re-rendered
// on the main thread when the modal opens.
const PdfPreviewModal = ({ preview, onHide }) => (
  <Modal show={Boolean(preview)} size="xl" onHide={onHide}>
    {preview && (
      <div className="position-relative">
        <a href={preview.url} download={preview.fileName}>
          <Button
            variant="light"
            className="position-absolute btn btn-light border border-4 border-secondary mb-5 rounded-5"
            style={{ bottom: "7rem", left: "2rem" }}
          >
            <i className="fa-solid fa-download"></i> Download PDF
          </Button>
        </a>
        <iframe
          src={preview.url}
          title={preview.fileName}
          style={{ width: "100%", height: "100vh", border: "none" }}
        />
      </div>
    )}
  </Modal>
);

export default PdfPreviewModal;
